
<div v-if="showFeature">
  <slot></slot>
</div>
